import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/languages/en.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "180c81e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('180c81e5', __exports__)) {
    api.reload('180c81e5', __exports__)
  }
  
}


export default __exports__